import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)

import EnvBase from '../env.js'
import SvrApi from '../svrapi.js'

var PT = EnvBase.PT
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouterMap = [
    { path: '/login', component: _import('login/index'), hidden: true },
    // { path: '/404', component: _import('404'), hidden: true },
    // ，默认跳转地址

    // 路径错误，默认跳转地址
  {
    path: '*',
    component: Layout,
    redirect: '/homepage/homepage',
    hidden: true
  },
  {
    path: '/homepage',
    component: Layout,
    icon: 'shouye',
    noDropdown: true,
    hidden: true,
    children: [{ path: 'homepage', name: '首页', hidden: true, component: _import('homepage/homepage') }]
  },
  {
    path: '/commodityshpMat',
    component: Layout,
    redirect: 'noredirect',
    name: '商品购物',
    icon: 'goods',
    hidden: true,
    children: [{
      path: '/commodityshpMat/commodityodr',
      component: _import('commodityshpMat/commodityodr/index'),
      name: '',
      noDropdown: true,
      children: [{
        path: 'order_list',
        component: _import('commodityshpMat/commodityodr/order_list'),
        name: '商品订单'
      },
      {
        path: 'order_detail',
        component: _import('commodityshpMat/commodityodr/order_detail'),
        name: '商品订单 / 订单详情'
      }
      ]
    },
    {
      path: '/commodityshpMat/commoditydsn',
      component: _import('commodityshpMat/commoditydsn/index'),
      name: '商品配送',
      children: [{
        path: 'distribution_list',
        component: _import('commodityshpMat/commoditydsn/distribution_list'),
        name: '配送列表'
      },
      {
        path: 'distribution_record',
        component: _import('commodityshpMat/commoditydsn/distribution_record'),
        name: '配送记录'
      },
      {
        path: 'wait_distribution',
        component: _import('commodityshpMat/commoditydsn/wait_distribution'),
        name: '等待配送'
      },
      {
        path: 'list_detail',
        component: _import('commodityshpMat/commoditydsn/list_detail'),
        name: '列表详情',
        hidden: true
      },
      {
        path: 'record_detail',
        component: _import('commodityshpMat/commoditydsn/record_detail'),
        name: '记录详情',
        hidden: true
      },
      {
        path: 'wait_detail',
        component: _import('commodityshpMat/commoditydsn/wait_detail'),
        name: '等待详情',
        hidden: true
      }
      ]
    },
    {
      path: '/commodityshpMat/commoditymat',
      component: _import('commodityshpMat/commoditymat/index'),
      name: '商品管理',
      children: [{
        path: 'commodity_list',
        component: _import('commodityshpMat/commoditymat/commodity_list'),
        name: '商品列表'
      },
      {
        path: 'commodity_class',
        component: _import('commodityshpMat/commoditymat/Commodity_class'),
        name: '商品分类'
      }
      ]
    }
    ]
  },
  {
    path: '/demandMat',
    component: Layout,
    redirect: 'noredirect',
    icon: 'demand',
    name: '点播付费',
    hidden: true,
    children: [{
      path: 'demandOdr/demandOdr_list',
      component: _import('demandMat/demandOdr/demandOdr_list'),
      name: '点播订单',
      noDropdown: true
    }]
  },
  {
    path: '/financeMat',
    component: Layout,
    redirect: 'noredirect',
    name: '财务数据',
    icon: 'capital',
    hidden: true,
    children: [{
      path: '/financeMat/revenue_sts',
      component: _import('financeMat/revenue_sts/index'),
      name: '营收统计',
      children: [{
        path: 'shopping',
        component: _import('financeMat/revenue_sts/shopping_rve'),
        name: '购物营收'
      },
      {
        path: 'demand_rve',
        component: _import('financeMat/revenue_sts/demand_rve'),
        name: '点播营收'
      },
      {
        path: 'revenue_detail',
        component: _import('financeMat/revenue_sts/revenue_detail'),
        name: '详情',
        hidden: true
      }
      ]
    },
    {
      path: '/financeMat/financial_set',
      component: _import('financeMat/financial_set/index'),
      name: '财务结算',
      children: [{
        path: 'shopping_set',
        component: _import('financeMat/financial_set/shopping_set'),
        name: '购物结算'
      },
      {
        path: 'demand_set',
        component: _import('financeMat/financial_set/demand_set'),
        name: '点播结算'
      },
      {
        path: 'shopping_detail',
        component: _import('financeMat/financial_set/shopping_detail'),
        name: '购物结算 / 结算明细',
        hidden: true
      }
      ]
    }
    ]
  },
  {
    path: '/storeMat',
    component: Layout,
    redirect: 'noredirect',
    name: '门店管理',
    icon: 'store',
    children: [{
      path: '/storeMat/interfaceMat',
      component: _import('storeMat/interfaceMat/index'),
      name: '界面设置',
      children: [{
        path: 'examine',
        component: _import('storeMat/interfaceMat/examine'),
        name: '内容审核',
        hidden: true
      },
      {
        path: 'Interfaceone',
        component: _import('storeMat/interfaceMat/Interfaceone'),
        name: '界面一'
      },
      {
        path: 'Interfacetwo',
        component: _import('storeMat/interfaceMat/Interfacetwo'),
        name: '界面二'
      },
      {
        path: 'Interfacethree',
        component: _import('storeMat/interfaceMat/InterfaceThree'),
        name: '界面三'
      },
      {
        path: 'Interfacefour',
        component: _import('storeMat/interfaceMat/InterfaceFour'),
        name: '界面四'
      },
      {
        path: 'Interfacefive',
        component: _import('storeMat/interfaceMat/interfaceFive/index'),
        name: '界面五'
      },
      {
        path: 'InterfaceSix',
        component: _import('interfaceSetting/interfaceSix/index'),
        name: '界面六'
      },
      {
        path: 'InterfaceSeven',
        component: _import('interfaceSetting/interfaceSeven/index'),
        name: '界面七'
      },
      {
        path: 'InterfaceEight',
        component: _import('interfaceSetting/interfaceEight/index'),
        name: '界面八'
      },
      {
        path: 'interfaceEighthotelIntroduction',
        component: _import('interfaceSetting/interfaceEight/hotelIntroduction/index'),
        name: '界面八通用设置',
        hidden: true
      },
      {
        path: 'interfaceEighttechnicianService',
        component: _import('interfaceSetting/interfaceEight/technicianService/index'),
        name: '界面八技师设置',
        hidden: true
      },
      {
        path: 'interfaceSevenhotelIntroduction',
        component: _import('interfaceSetting/interfaceSeven/hotelIntroduction/index'),
        name: '模块设置-酒店',
        hidden: true
      },
      {
        path: 'interfaceSeventechnicianService',
        component: _import('interfaceSetting/interfaceSeven/technicianService/index'),
        name: '模块设置-技师',
        hidden: true
      },
      {
        path: 'hotelIntroduction',
        name: '模块设置-酒店',
        component: _import('interfaceSetting/hotelIntroduction/index'),
        meta: 'interface_settings_five',
        hidden: true
      },
      {
        path: 'technicianService',
        name: '模块设置-足浴',
        component: _import('interfaceSetting/technicianService/index'),
        meta: 'interface_settings_five',
        hidden: true
      },
      {
        path: 'Interfacetnews',
        component: _import('storeMat/interfaceMat/Interfacetnews'),
        name: '消息管理'
      },
      {
        path: 'Interfacetwosts',
        component: _import('storeMat/interfaceMat/Interfacetwosts'),
        name: '界面统计'
      },
      {
        path: 'consolepwd',
        component: _import('storeMat/interfaceMat/consolepwd'),
        name: '界面设置'
      },
      {
        path: 'welcome',
        component: _import('storeMat/interfaceMat/welcome'),
        name: '欢迎页面'
      },
      {
        path: 'Interfacedetail',
        component: _import('storeMat/interfaceMat/Interfacedetail'),
        name: '界面详情',
        hidden: true
      },
      {
        path: 'newsrecord',
        component: _import('storeMat/interfaceMat/newsrecord'),
        name: '消息记录',
        hidden: true
      },
      {
        path: 'meituanhotel',
        component: _import('interfaceSetting/meituanHotel/index'),
        name: '美团酒店'
      }
      ]
    },
    {
      path: '/storeMat/employeeMat',
      component: _import('storeMat/employeeMat/index'),
      name: '员工管理',
      hidden: true,
      children: [{
        path: 'staff_list',
        component: _import('storeMat/employeeMat/staff_list'),
        name: '员工列表'
      },
      {
        path: 'role_list',
        component: _import('storeMat/employeeMat/role_list'),
        name: '角色列表'
      },
      {
        path: 'role_detail',
        component: _import('storeMat/employeeMat/role_detail'),
        name: '角色列表 / 角色详情',
        hidden: true
      }
      ]
    },
    // {
    //   path: 'opinionMat/opinion_list',
    //   component: _import('storeMat/opinionMat/opinion_list'),
    //   name: '意见反馈',
    //   noDropdown: true
    // },
    {
      path: 'roomMat/room_list',
      component: _import('storeMat/roomMat/room_list'),
      name: '房间管理',
      noDropdown: true
    }
            // {
            //     path: 'journalMat/journal_list',
            //     component: _import('storeMat/journalMat/journal_list'),
            //     name: "操作日志",
            //     noDropdown: true,
            // },
            // {
            //     path: 'functionMat/function_list',
            //     component: _import('storeMat/functionMat/function_list'),
            //     name: "功能宣传",
            //     noDropdown: true,
            // },

    ]
  },
  {
    path: '/storeYb',
    component: Layout,
    icon: 'capital',
    name: '技术服务费',
    children: [{
      path: 'scavengingPayment/payment',
      component: _import('storeYb/scavengingPayment/payment'),
      name: '扫码付费'
    },
    {
      path: 'payRecord/recordList',
      component: _import('storeYb/payRecord/recordList'),
      name: '付费记录'
    }
    ]
  },
  {
    path: '/leaseManagement',
    component: Layout,
    name: '租赁管理',
    icon: 'lease',
    children: [{
      path: '/lease',
      component: _import('leaseManagement/index'),
      name: '租赁管理2',
      children: [
        {
          path: 'device',
          component: _import('leaseManagement/lease/device/index'),
          name: '租赁设备'
        },
        {
          path: 'useRecord',
          component: _import('leaseManagement/lease/useRecord/index'),
          name: '使用详情'
        },
        {
          path: 'useDetailList/:id',
          component: _import('leaseManagement/lease/useDetailList/index'),
          name: '使用详情 / 详情',
          hidden: true
        },
        {
          path: 'payRecord',
          component: _import('leaseManagement/lease/payRecord/index'),
          name: '购买密钥'
        },
        {
          path: 'disbuteRecords',
          component: _import('leaseManagement/lease/disbuteRecords/index'),
          name: '分发记录'
        },
        {
          path: 'roomRental',
          component: _import('leaseManagement/lease/roomRental/index'),
          name: '房间租赁'
        }
      ]
    },{
      path: '/lease3',
      component: _import('leaseManagement/index'),
      name: '租赁管理3',
      children: [
        {
          path: 'roomAuthorization',
          component: _import('leaseManagement/lease3/roomAuthorization'),
          name: '客房授权'
        },
        {
          path: 'authorizationRecords',
          component: _import('leaseManagement/lease3/authorizationRecords'),
          name: '授权记录'
        },
        {
          path: 'dataStatistics',
          component: _import('leaseManagement/lease3/dataStatistics'),
          name: '数据统计'
        },
        {
          path: 'dataStatisticsDetails',
          component: _import('leaseManagement/lease3/dataStatisticsDetails'),
          name: '数据统计 / 详情',
          hidden: true
        },
      ]  
    }
    ]
  },
  {
    path: '/afterSalesManage',
    component: Layout,
    icon: 'lease',
    meta: 'after_sales_manage',
    name: '售后管理',
    children: [
      {
        path: 'repairOrder',
        name: '维修工单',
        component: _import('afterSalesManage/repairOrder/index'),
        meta: 'repair_order'
      },
      {
        path: 'repairOrderAdd',
        name: '维修工单 / 新增维修',
        component: _import('afterSalesManage/repairOrder/addMaintenance'),
        hidden: true
      },
      {
        path: 'repairOrderDetail',
        name: '维修工单 / 工单详情',
        component: _import('afterSalesManage/repairOrder/detailOrder'),
        hidden: true
      }
    ]
  },
  {
    path: '/gameManager',
    component: Layout,
    name: '游戏管理',
    icon: 'lease',
    meta: 'after_sales_manage',
    children: [
      {
        path: 'flowOrder',
        component: _import('gameManager/flowOrder'),
        name: '订单管理',
        meta: 'repair_order'
      }
    ]
  },
  {
    path: '/currencyApp',
    component: Layout,
    icon: 'lease',
    // meta: 'currency_app',
    name: '更新管理',
    children: [
      {
        path: 'generalApp',
        name: '通用应用',
        component: _import('currencyApp/generalApp/index')
      },
      {
        path: 'appUninstall',
        name: '应用卸载',
        component: _import('currencyApp/appUninstall/index')
      }
    ]
  }
]

export default new Router({
    // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js